import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import useContextService from "hooks/useContextService";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { onExport } from "utils/helper";
import SearchOrderTab from "./SearchOrder";
import useAxios from "hooks/useAxios";
import { getUpdatedFilterLatest } from "utils/helper";
import Poreconciliation from "./PoReconciliation";
import ReviewPurchaseOrder from "./ReviewPurchaseOrder";
import ErrorBoundary from "components/ErrorBoundary";
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { cloneDeep } from "lodash";
import Loader from "components/Loader";

let filters = [];
let role = ['SUPADM', 'SBPFADM']
const PurchaseOrder = (props) => {

  const { orgId } = props;
  const API = useAxios();

  const {
    states: { searchOrder },
    setStates,
    resetStates
  } = useContextService();
  const [collapseSider, setcollapseSider] = useState(false);
  const [collIcon, setCollIcon] = useState(faAngleUp);
  const [columnFilters, setColumnFilters] = useState([]);
  const [loading, setLoading] = useState(false);
  const { search, coveredEntity, searchTerms, claimStatusID } = searchOrder;
  const [key, setkey] = useState('searchorder');
  const [reset, setReset] = useState(false);
  const [reset1, setReset1] = useState(false);
  const [reset2, setReset2] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  const [data, setData] = useState([]);
  const [totalitem, setTotalItem] = useState(0);
  const [userRoles, setUserRoles] = useState([]);
  const [SelectedAccumulator, setSelectedAccumulator] = useState("");
  const [resetFilterFlag, SetResetFilterFlag] = useState(false);
  // const { tenantID } = orgId;
  const { token_type, access_token, profile } =
    JSON.parse(localStorage.getItem('pharmaforce')) || {};
  const { sub, roles } = profile || {};
  const toggleSider = () => {
    setcollapseSider(!collapseSider);
    if (!collapseSider) {
      setCollIcon(faAngleDown);
    } else {
      setCollIcon(faAngleUp);
    }
  };
  useEffect(() => {
    if (Array.isArray(roles)) {
      setUserRoles(roles);
    }
    else {
      var obj = [];
      obj.push(roles);
      setUserRoles(obj);
    }
  }, [roles])
  useEffect(() => {
    if (searchTerms.coveredEntityID) handleSearch(searchTerms);
  }, []);

  const onKeyChange = (k) => {
    debugger;
    setkey(k);
  const min = 1;
                const max = 100;
              const rand = min + Math.random() * (max - min);
              setResetKey(rand);
    if (k == 'searchorder') {
      setReset(!reset);
      resetStates('searchOrder')
    }
    if (k == 'poreconciliation') {
      setReset1(!reset1);
      resetStates('poReconciliation')
    }
    if (k == 'revieworder') {
      setReset2(!reset2);
      resetStates('reviewOrder')
    }
  };
  const refetch = (hastrue) => {
    debugger;
    setColumnFilters([]);
    searchOrder.search.currentPage = 1;
    if (hastrue) {
      debugger
      fetchPurchaseOrders(search, searchTerms.actButton);
    }
  };
  const fetchPurchaseOrders = async (filters, activeButton) => {
    debugger
    if (!orgId?.tenantID) return null;
    if (window.selectedCoveredEntittyId == "" || window.selectedCoveredEntittyId == undefined) return null;
    setLoading(true)
    try {
      if (filters.AccumulatorIDs.length > 0) {
        const { data } = await API.post(
          `SBTenant/${orgId.tenantID}/PurchaseOrder/GetAll/${activeButton}`,
          filters,
          { hasDefaultURL: true }
        );

        if (data.items != null) {
          setData(data.items);                  
          setCollIcon(faAngleDown);
          setTotalItem(data.totalRecords);         
          setLoading(false);
        } else {
          setData([]);
          setTotalItem(0);
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const onReset = () => {
    setcollapseSider(false);
    setData([]);
    setTotalItem(0);
    SetResetFilterFlag(true);
  };

  const handleSearch = async (filter) => {
    const {
      accumulationIDs,
      poNumber,
      invoiceNumber,
      orderStatusId,
      accountTypeId,
      AccountTypeID,
      activeButton,
      orderStatus,
      hasHNselected,
      HospitalId

    } = filter;

    if (orderStatus) {
      filters = getUpdatedFilterLatest("POStatusID", orderStatus, filters);
    }

    if (poNumber) {
      filters = getUpdatedFilterLatest('poid', poNumber, filters);
    }

    const tableRes = document.querySelector(".table-responsive");
    tableRes.scrollLeft = 0;
    //search.filters = filters;
    //search.ChainPharmacyIDs = cpIds;
    search.AccumulatorIDs = accumulationIDs;
    setSelectedAccumulator(accumulationIDs);
    search.POStatusID = orderStatus ? orderStatus : 0;
    search.AccountTypeID = AccountTypeID;
    //  search.orderStatus = orderStatus;
    search.HospitalId = hasHNselected ? hasHNselected : null;

    search.Poid = parseInt(poNumber);
    search.Invoice = invoiceNumber;
    debugger
    await fetchPurchaseOrders(search, activeButton);
  };
  const handleSearchColumnFiltersClear = () => {
    debugger;
    setColumnFilters([]);
  };
  const handleSearchColumnFilters = async (columnFilters) => {
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
      setColumnFilters(columnFilters)
    }
    debugger
    searchOrder.search.currentPage = 1;
    filterObj.currentPage = 1;
    await fetchPurchaseOrders(filterObj, searchTerms.actButton);
  };

  const handlePageChange = (filter, haveColFilter) => {
    debugger
    updatePoSearch(filter);
    if (haveColFilter) {
      const filterObj = cloneDeep(search);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;
      searchOrder.search = { ...searchOrder.search };
      fetchPurchaseOrders(filterObj, searchTerms.actButton);
    } else {
      debugger
      fetchPurchaseOrders(filter, searchTerms.actButton);
      searchOrder.search = { ...searchOrder.search, ...filter };
    }
    setStates("searchOrder", searchOrder);
  };
  
  const updatePoSearch = (filter) => {
      searchOrder.search.currentPage = filter.currentPage;
      searchOrder.search.pageSize = filter.pageSize;
      searchOrder.search.orderBy= filter.orderBy;
      searchOrder.search.order= filter.order;
  }

  return (
    <div>
      {loading && <Loader opacity={0.01} color='black' />}

      <Container fluid className='width_info bin_info'>
        <Card className="border-0 shadow-top">
          <CardBody className="">
            <ErrorBoundary>
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                // onSelect={(k) => setkey(k)}
                onSelect={(k) => onKeyChange(k)}
                className="mb-0"
              >
                <Tab eventKey="searchorder" title="Search Order">
                  <SearchOrderTab
                    columnFilters={columnFilters}
                    reset={reset}
                    SelectedAccumulator={SelectedAccumulator}
                    refetch={refetch}
                    data={data}
                    totalitem={totalitem}
                    orgId={orgId}
                    search={search}
                    onSearch={handleSearch}
                    onReset={onReset}
                    onPageChange={handlePageChange}
                    toggleSider={toggleSider}
                    collIcon={collIcon}
                    collapseSider={collapseSider}
                    onSearchColumnFilters={handleSearchColumnFilters}
                    handleSearchColumnFiltersClear={handleSearchColumnFiltersClear}
                    loading={loading}
                    setLoading={setLoading}
                    resetFilterFlag={resetFilterFlag}
                    SetResetFilterFlag={SetResetFilterFlag}
                    tabKey={key}
                    resetKey={resetKey}
                  />
                </Tab>
                <Tab eventKey="poreconciliation" title="PO Reconciliation">
                  <Poreconciliation
                    reset={reset1}
                    refetch={refetch}
                    orgId={orgId}
                    loading={loading}
                    tabKey={key}
                    setLoading={setLoading}
                    resetKey={resetKey}
                  />
                </Tab>
                <Tab eventKey="revieworder" title="Review Order">
                  <ReviewPurchaseOrder
                    orgId={orgId}
                    setkey={setkey}
                     tabKey={key}
                    reset={reset2}
                    loading={loading}
                    setLoading={setLoading}
                  />
                </Tab>
              </Tabs>
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PurchaseOrder;
